import { render, staticRenderFns } from "./Plantilla.vue?vue&type=template&id=214ba824"
import script from "./Plantilla.vue?vue&type=script&lang=js"
export * from "./Plantilla.vue?vue&type=script&lang=js"
import style0 from "./Plantilla.vue?vue&type=style&index=0&id=214ba824&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports